// extracted by mini-css-extract-plugin
module.exports = {"control":"SegmentedControl_control__2xHqY","segment":"SegmentedControl_segment__2hJRZ","active":"SegmentedControl_active___OjxS","disabled":"SegmentedControl_disabled__OMlIu"};